import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { Row, Col, Typography, Button } from 'antd';
import { MinusCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

/**
 * Renders one hint row: plain string (e.g. from Gemini) or the full hint object editor.
 */
export function HintArrayEntry ({
  name,
  index,
  questionIndex,
  remove,
  selectedLearnerTypes,
  selectedHintTypes,
  renderObjectHint: RenderObjectHint
}) {
  return (
    <Field name={name} subscription={{ value: true }}>
      {({ input }) =>
        typeof input.value === 'string' ? (
          <Row
            gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}
            style={{ padding: '12px 5px' }}
            align='top'
          >
            <Col flex='auto' style={{ paddingLeft: 0 }}>
              <Title level={5} style={{ fontWeight: 'bolder' }}>
                Hint {index + 1}
              </Title>
              <Text>{input.value}</Text>
            </Col>
            <Col flex='none' style={{ paddingTop: 36 }}>
              <Button
                type='text'
                icon={<MinusCircleOutlined style={{ color: '#BDBDBD', fontSize: 20 }} />}
                onClick={(eventOnClickRemoveHintButton) => {
                  eventOnClickRemoveHintButton.preventDefault();
                  eventOnClickRemoveHintButton.stopPropagation();
                  remove(index);
                }}
              />
            </Col>
          </Row>
        ) : (
          <RenderObjectHint
            name={name}
            index={index}
            questionIndex={questionIndex}
            remove={remove}
            selectedLearnerTypes={selectedLearnerTypes}
            selectedHintTypes={selectedHintTypes}
          />
        )}
    </Field>
  );
}

HintArrayEntry.propTypes = {
  name: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  questionIndex: PropTypes.number,
  remove: PropTypes.func.isRequired,
  selectedLearnerTypes: PropTypes.array,
  selectedHintTypes: PropTypes.array,
  renderObjectHint: PropTypes.elementType.isRequired
};
